import logo from './logo.svg';
import './App.css';
import {
  Link
} from "react-router-dom";
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <ul className="nav navbar-nav">
      <li><Link to="/">首頁</Link></li>
      <li><Link to="/cashier">收銀台</Link></li>


      </ul>
      </header>
    </div>
  );
}

export default App;
